import {raise} from '@/utilities/helpers'
import {useContext} from 'react'
import {PreviousMedicalReportContext} from '../contexts/PreviousMedicalReportContext'

export const useMedicalPreviousReportContext = () => {
    const context = useContext(PreviousMedicalReportContext)
    return context ?? raise('useMedicalPreviousReportContext must be in a PreviousMedicalReportProvider')
}
